import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-D8KZBBYZ8V';

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    console.warn('[ANALYTICS] trackEvent skipped — gtag unavailable', { name, params });
    return;
  }
  window.gtag('event', name, params);
  if (import.meta.env.MODE !== 'production') {
    console.log('[ANALYTICS] event fired:', name, params);
  }
}

const PAGE_TITLES = {
  '/': 'Katbot - Home',
  '/licensing': 'Katbot - Licensing',
  '/dashboard': 'Katbot - Dashboard',
};

function getPageTitle(pathname) {
  return PAGE_TITLES[pathname] ?? 'Katbot';
}

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'function') return;
    // Fire an explicit page_view event on each route change instead of re-running
    // gtag('config', …), which replaces the bootstrap config (drops send_page_view:false
    // and traffic_type) and triggers an extra implicit page_view.
    const title = document.title || getPageTitle(location.pathname);
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: title,
      page_location: window.location.href,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location]);
}
